import {
  OmakasePolymorphicComponent,
  OmakasePolymorphicComponentProps,
  OmakasePolymorphicRootComponent,
} from 'omakase/utils/OmakasePolymorphicComponent';
import { Theme } from '@emotion/react';
import { switcherGroup } from 'omakase/PadButton/padButtonCssDefs';
import React from 'react';

export interface SwitcherGroupProps {
  /**
   * Whether or not the group has a background color
   */
  background: boolean;
}

const SwitcherGroupDefaultElement = 'div';
type SwitcherGroupTypeGuard = 'div';

const SwitcherGroup: OmakasePolymorphicComponent<
  SwitcherGroupProps,
  typeof SwitcherGroupDefaultElement,
  SwitcherGroupTypeGuard
> = React.forwardRef(
  <E extends React.ElementType = typeof SwitcherGroupDefaultElement>(
    {
      component,
      background,
      children,
      ...rest
    }: OmakasePolymorphicComponentProps<SwitcherGroupProps, E, SwitcherGroupTypeGuard>,
    ref: React.Ref<HTMLDivElement> | undefined
  ) => {
    const Component: React.ElementType = component || SwitcherGroupDefaultElement;
    return (
      <OmakasePolymorphicRootComponent
        ref={ref}
        component={Component}
        css={(theme: Theme) => switcherGroup(theme, background)}
        role="group"
        {...rest}
      >
        {children}
      </OmakasePolymorphicRootComponent>
    );
  }
);

export default SwitcherGroup;
